import { moduleProviderFactory } from 'core/providers';
import { ShipmentInfoList } from 'modules/shipment-info/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.shipment-status-return',
				pattern: '/shipment-info',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.shipment-info.list',
						pattern: '',
						authorization: 'shipmentStatusSection.read',
						component: ShipmentInfoList,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/shipment-info/config.js